export const HEADER_HEIGHT_PX = 64;

export const HEADER_DESKTOP_HEIGHT_PX = 84;

export const HEADER_TABLET_HEIGHT_PX = 120;

export const HEADER_PROFILE_MENU_OFFSET_PX = 22;
